import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=8483ef2e&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=8483ef2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8483ef2e",
  null
  
)

export default component.exports